import { render, staticRenderFns } from "./KioskKpiCard.vue?vue&type=template&id=e8186508&scoped=true"
import script from "./KioskKpiCard.vue?vue&type=script&lang=js"
export * from "./KioskKpiCard.vue?vue&type=script&lang=js"
import style0 from "./KioskKpiCard.vue?vue&type=style&index=0&id=e8186508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8186508",
  null
  
)

export default component.exports